import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", ...rest }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y: 36 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        {...rest}
    >
        {children}
    </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
    <span className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.95, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.span>
    </span>
);

export const Overline = ({ children, light = false }) => (
    <p
        className={`text-xs uppercase tracking-[0.3em] font-medium ${
            light ? "text-amber-300" : "text-[#C85A17]"
        }`}
    >
        {children}
    </p>
);
